import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="footer-logo">
              <img 
                src="/dark-mode-lighthouse.svg" 
                alt="Lighthouse Data Partners" 
                className="footer-logo-icon"
              />
              <span className="footer-logo-text">Light<span>House</span> Data Partners</span>
            </div>
            <p className="footer-tagline">
              Your external data team. We help growing companies operate with better data — 
              without the overhead of building an in-house team.
            </p>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <nav className="footer-links">
              <Link to="/services#foundation" className="footer-link">Data Foundation</Link>
              <Link to="/services#visibility" className="footer-link">Dashboards & Visibility</Link>
              <Link to="/services#forecasting" className="footer-link">Forecasting & Planning</Link>
              <Link to="/services#automation" className="footer-link">Automation & AI</Link>
              <Link to="/services#support" className="footer-link">Ongoing Support</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <nav className="footer-links">
              <Link to="/how-it-works" className="footer-link">How It Works</Link>
              <Link to="/who-its-for" className="footer-link">Who It's For</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <nav className="footer-links">
              <a href="mailto:hello@lighthousedatapartners.com" className="footer-link">hello@lighthousedatapartners.com</a>
              <a href="https://www.linkedin.com/in/lighthouse-data-partners-a9526a3a2/" className="footer-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Lighthouse Data Partners. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="#" className="footer-legal-link">Privacy Policy</a>
            <a href="#" className="footer-legal-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
